export var LocalLieState;
(function (LocalLieState) {
    LocalLieState[LocalLieState["None"] = 0] = "None";
    LocalLieState[LocalLieState["Pending"] = 1] = "Pending";
    LocalLieState[LocalLieState["Complete"] = 2] = "Complete";
})(LocalLieState || (LocalLieState = {}));
//# sourceMappingURL=LocalLieState.js.map